export const ICONS = {
  organisation: "uil-building",
  personne: "uil-users-alt",
  setting: "uil-cog",
  adresseAlt: "uil-location-pin-alt",
  info: "uil-info-circle",
  contact: "uil-receipt-alt",
  fonction: "uil-bag-alt",
  type_unite: "uil-pathfinder-unite",
  formation: "uil-graduation-hat",
  direction: "mdi mdi-shield-account",
  detail: "uil uil-bookmark",
  add: "uil-plus",
  instance: "uil-meeting-board",
  events: "uil-calender",
  message: "uil-message",
  cotisation: "uil-euro-circle",
  paiement: "uil-atm-card",
  historique: " uil-history",
};

export const Header = {
  adresse: {
    icon: ICONS.adresseAlt,
    label: "Adresse",
  },
  infoGenerale: {
    icon: ICONS.info,
    label: "Information générale",
  },
  contact: {
    icon: ICONS.contact,
    label: "Contacts",
  },
  membre: {
    icon: ICONS.personne,
    label: "Membres",
  },
  formation: {
    icon: ICONS.formation,
    label: "Formation",
  },
};
